export default {
  dbb_filter_all: '全部',
  dbb_filter_all_info: '展示所有{name}的去重用户数据',
  dbb_country_all: 'All表示当前对应国家列表的全部数据汇总。',
  dbb_filter_pcu_title: 'PCU 区间',
  dbb_filter_download_title: '下载量区间',
  dbb_filter_revenue_title: '收入区间',
  dbb_filter_pcu_left_placeholder: '最低',
  dbb_filter_pcu_right_placeholder: '最高',
  dbb_filter_revenue_left_placeholder: '最低',
  dbb_filter_revenue_right_placeholder: '最高',
  dbb_filter_download_left_placeholder: '最低',
  dbb_filter_download_right_placeholder: '最高',
  dbb_filter_download_by_percentile: '按百分位',
  dbb_filter_download_number_og_top10: '按排名数量',
  dbb_filter_download_customized_range: '自定义范围',
  dbb_filter_download_by_percentile_top: '按百分位 - 前',
  dbb_filter_download_by_percentile_of_games: '% 的游戏',
  dbb_filter_download_by_top_game: '按排名数量 - 前',
  dbb_filter_download_by_top_game_of_games: '的游戏',

  dbb_filter_input_error: '输入错误，请输入整数，勿带特殊字符',
  dbb_filter_input_less_min: '最大值不能小于最小值',
  dbb_filter_input_more_max: '最小值不能大于最大值',
  dbb_filter_input_percent_max: '输入错误，请输入100以内的整数',

  dbb_filter_pcu_tooltip: 'Steam历史最高在线人数',
  dbb_filter_revenue_tooltip: '游戏正式发行后Steam平台首年总收入，数据源来自VG Insights',
  dbb_filter_download_tooltip: '游戏正式上线后首年的下载量',
  dbb_filter_release_time_tooltip: "选择一段时间以选中对应时间段内发布的游戏。",
};